export const styles = () => ({
  '&.dn-table': {
    background: '#FFFFFF',
    border: '1px solid rgba(75, 75, 75, 0.1)',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
    borderRadius: '12px',
    '.dn-titles': {
      padding: '20px 40px 0 40px',
    },
  },
  '&.dn-toolbar': {
    maxWidth: '450px',
    minWidth: '450px',
    '.dn-title-toolbar': {
      fontWeight: '700',
      fontSize: '18px',
      lineHeight: '22px',
      color: '#4B4B4B',
    },
    '.dn-titles': {
      position: 'relative',
      padding: '10px 20px 4px 20px',
      '.MuiLinearProgress-root': {
        position: 'absolute',
        left: '0',
        right: '0',
        bottom: '0',
      },
    },
    '.dn-notification': {
      padding: '10px 20px !important',
      p: {
        fontSize: '12px !important',
        lineHeight: '14px !important',
      },
    },
    '.dn-unread': {
      fontSize: '12px !important',
    },
    '.dn-actions': {
      '.MuiButton-root': {
        fontSize: '12px !important',
      },
      '& > div': {
        marginLeft: '20px',
        p: {
          fontSize: '12px',
        },
      },
    },
    '.dn-notification-title': {
      fontSize: '14px !important',
      marginLeft: '0 !important',
      marginRight: '0 !important',
      marginBottom: '0 !important',
      paddingBottom: '15px !important',
      paddingLeft: '20px !important',
      paddingRight: '20px !important',
      position: 'sticky',
      top: '0',
      background: '#fff',
      zIndex: '1',
    },
  },
  position: 'relative',
  '.dn-notifications-all': {
    maxHeight: 'calc(100vh - 338px)',
    overflowY: 'auto',
  },
  '.dn-unread': {
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    color: '#4B4B4B',
  },
  '.dn-actions': {
    '.MuiButton-root': {
      border: 'none !important',
      fontSize: '14px !important',
      color: '#4B4B4B !important',
    },
    '& > div': {
      marginLeft: '30px',
      p: {
        fontSize: '14px',
        color: '#4B4B4B',
      },
    },
  },
  '.dn-pagination': {
    padding: '10px 20px',
    position: 'relative',
    borderTop: '1px solid #ececec',
    marginTop: '-1px',

    '.MuiIconButton-root:not(.Mui-disabled)': {
      svg: {
        color: 'rgba(0, 0, 0, 0.54)',
      },
    },
    '.MuiTablePagination-displayedRows': {
      fontSize: '12px',
      lineHeight: '14px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
});
